var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03407 15.9999C6.03407 13.7199 7.8874 11.8666 10.1674 11.8666H15.5007V9.33325H10.1674C6.4874 9.33325 3.50073 12.3199 3.50073 15.9999C3.50073 19.6799 6.4874 22.6666 10.1674 22.6666H15.5007V20.1333H10.1674C7.8874 20.1333 6.03407 18.2799 6.03407 15.9999ZM11.5007 17.3333H22.1674V14.6666H11.5007V17.3333ZM23.5007 9.33325H18.1674V11.8666H23.5007C25.7807 11.8666 27.6341 13.7199 27.6341 15.9999C27.6341 18.2799 25.7807 20.1333 23.5007 20.1333H18.1674V22.6666H23.5007C27.1807 22.6666 30.1674 19.6799 30.1674 15.9999C30.1674 12.3199 27.1807 9.33325 23.5007 9.33325Z",
    fill: "#2E2B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.5d3dcf3eb5e6afb91f9d8cdca4b1e9f6.svg";
export { ForwardRef as ReactComponent };